<template>
    <v-container fluid>
        <v-row class="my-2">
            <v-col cols="12" class="text-left">
                <p class="mb-0">{{$t("page.events.pricing.text3")}}</p>
                <p v-if="maxRowPF" style="color:red;">{{ $t("page.events.createRegistrant.maxpf") }}</p>
            </v-col>
            <v-col cols="12" class="text-left">
                <v-btn color="primary" dark class="primary" @click="openModalPF()">
                    <v-icon left dark>fa-plus</v-icon>
                    {{ $t('common.form.add-information') }}
                </v-btn>
            </v-col>
            <v-col cols="12" class="pt-0">
                <v-data-table 
                    :headers="headersPricingFriends" 
                    :items="rowsSpectatorsL" 
                    class="elevation-1"
                    :footer-props="{
                        'items-per-page-text': $t('dataTable.rowsPerPageText'),
                        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                    }"
                    :no-data-text="$t('dataTable.noDataText')"
                    :headerProps="{
                        'sort-by-text': $t('dataTable.sortByText')
                    }"
                >
                    <template v-slot:top>
                        <v-dialog v-model="dialogPricingF" max-width="600px" :transition="false" :persistent="!snack">
                            <v-form ref="formEventPriceFriend">
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">{{ titleModal }}</span>
                                    </v-card-title>
                                    <v-card-text>                                                    
                                        <v-row class="mt-2">
                                            <v-col cols="12" class="pb-0">
                                                <v-text-field dense outlined
                                                    :label="$t('common.table.price')" 
                                                    v-model="eventPriceFriend.price"
                                                    :rules="priceRules"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="pb-0">
                                                <v-text-field 
                                                    outlined dense 
                                                    :label="$t('common.table.message_english_customer')" 
                                                    :hint="$t('common.table.message_english')" persistent-hint
                                                    v-model="eventPriceFriend.english"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="pb-0">
                                                <v-text-field 
                                                    outlined dense 
                                                    :label="$t('common.table.message_french_customer')" 
                                                    :hint="$t('common.table.message_french')" persistent-hint
                                                    v-model="eventPriceFriend.french"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="pb-0">
                                                <v-text-field 
                                                    outlined dense 
                                                    :label="$t('common.table.message_spanish_customer')" 
                                                    :hint="$t('common.table.message_spanish')" persistent-hint
                                                    v-model="eventPriceFriend.spanish"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="pb-0">
                                                <v-text-field 
                                                    outlined dense 
                                                    :label="$t('common.table.min_age')"
                                                    v-model="eventPriceFriend.ageMin"
                                                    :rules="ageMinRules"
                                                    @blur="$refs.formEventPriceFriend.validate()"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="pb-0">
                                                <v-text-field 
                                                    outlined dense 
                                                    :label="$t('common.table.max_age')"
                                                    v-model="eventPriceFriend.ageMax"
                                                    :rules="ageMaxRules"
                                                    @blur="$refs.formEventPriceFriend.validate()"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <Alert :snackbar="snackDialog" :notificationMessage="msg_snack_dialog" @cancel="snackDialog = false" :type="color_snack_dialog" :right="true" :top="true" class="alert" />
                                        <v-btn color="darken-1" dark small @click="closePF">{{ $t('common.form.cancel') }}</v-btn>
                                        <v-btn color="darken-1" dark small @click="savePF" class="mr-2">{{ $t('common.form.save') }}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-form>
                        </v-dialog>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-icon small class="mr-2" @click="editItemPF(item)">mdi-pencil</v-icon>
                        <v-icon small @click="confirmDeletePF(item)">mdi-delete</v-icon>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <SGSNotificationConfirm v-if="dialogNotificationPF" :notificationMessage="$t('common.confirm-delete')" @cancel="dialogNotificationPF=false;" @agree="deleteItemPF" type='warning'/>
        <Alert :snackbar="snack" :notificationMessage="msg_snack" @cancel="snack = false" :type="color_snack" :right="true" :top="true" class="alert" />
    </v-container>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import Alert from "@/components/custom/notification/Alert.vue"

export default {
    mixins: [apiCalls],
    components: {SGSNotificationConfirm, Alert},
    data() {
        return {
            maxRowPF: false,
            rowsSpectatorsL: [],
            dialogPricingF: false,
            dialogNotificationPF: false,
            eventPriceFriend: {
                price: null,
                english: null,
                spanish: null,
                french: null,
                ageMin: null,
                ageMax: null
            },
            bandCreatePF: false,
            msg_snack: '',
            color_snack: "error",
            snack: false,
            msg_snack_dialog: '',
            color_snack_dialog: "error",
            snackDialog: false,
            titleModal: ''
        }
    },
    computed: {
        headersPricingFriends: function() {
            return [
                {
                    text: this.$t("common.table.description"),
                    value: "information"
                },
                {
                    text: this.$t("common.table.price"),
                    value: "price"
                },
                {
                    text: this.$t("common.table.min_age"),
                    value: "ageMin"
                },
                {
                    text: this.$t("common.table.max_age"),
                    value: "ageMax"
                },
                {
                    text: this.$t("common.table.actions"),
                    value: "actions",
                    sortable: false
                }
            ]
        },
        priceRules: function() {
            const regInt = new RegExp('[0-9]+');
            const regFloat = new RegExp(/[0-9]+\.[0-9]{1,2}/);
            return [
                v => !!v || this.$t("page.events.pricing.price-required"),
                (v) => {
                    const auxV = v ? v.toString() : "";
                    const resultInt = auxV.split(regInt).filter(el => el != "");
                    const resultFloat = auxV.split(regFloat).filter(el => el != "");
                    return !(resultInt.length > 0 && resultFloat.length > 0) || this.$t("page.events.pricing.price-invalid");
                }
            ];
        },
        ageMinRules: function() {
            const regInt = new RegExp('[0-9]+');
            return [
                (v) => {
                    const auxV = v ? v.toString() : "";
                    const resultInt = auxV.split(regInt).filter(el => el != "");
                    return !(resultInt.length > 0) || this.$t("page.events.pricing.age-invalid");
                },
                (v) => {
                    const auxV = v ? v.toString() : "";
                    const minAge = auxV.length > 0 ? parseInt(auxV) : 0;
                    const maxAge = this.eventPriceFriend.ageMax;
                    return minAge <= maxAge || this.$t("page.events.pricing.age-min-invalid");
                }
            ];
        },
        ageMaxRules: function() {
            const regInt = new RegExp('[0-9]+');
            return [
                (v) => {
                    const auxV = v ? v.toString() : "";
                    const resultInt = auxV.split(regInt).filter(el => el != "");
                    return !(resultInt.length > 0) || this.$t("page.events.pricing.age-invalid");
                },
                (v) => {
                    const auxV = v ? v.toString() : "";
                    const maxAge = auxV.length > 0 ? parseInt(auxV) : 0;
                    const minAge = this.eventPriceFriend.ageMin;
                    return minAge <= maxAge || this.$t("page.events.pricing.age-max-invalid");
                }
            ];
        }
    },
    methods: {
        showSnackBar(message, type) {
            this.msg_snack = message;
            this.color_snack = type;
            this.snack = true;
        },
        showSnackBarDialog(message, type) {
            this.msg_snack_dialog = message;
            this.color_snack_dialog = type;
            this.snackDialog = true;
        },
        openModalPF() {
            this.titleModal = this.$t("page.events.pricing.create_friend_family");
            this.dialogPricingF = true;
            this.bandCreatePF = true;       
            if(this.$refs.formEventPriceFriend) this.$refs.formEventPriceFriend.resetValidation();
        },
        closePF() {
            this.$refs.formEventPriceFriend.resetValidation();
            this.$refs.formEventPriceFriend.reset();
            this.bandCreatePF = false;
            this.dialogPricingF = false;
        },
        async savePF() {
            if(this.$refs.formEventPriceFriend.validate()) {
                const data = {
                    eventId: parseInt(this.$route.params.id),
                    price: this.eventPriceFriend.price,
                    spanish: this.eventPriceFriend.spanish,
                    french: this.eventPriceFriend.french,
                    english: this.eventPriceFriend.english,
                    ageMin: this.eventPriceFriend.ageMin,
                    ageMax: this.eventPriceFriend.ageMax
                };
                if(this.bandCreatePF){
                    const response = await this.api(
                        "post",
                        "/api/v1/promoter/eventRegistrationPrice/updateOrCreateCostPerson/"+ this.$route.params.id,
                        data
                    );
                    if(response.success) {
                        this.loadInformationLanguage();
                        this.bandCreatePF = false;
                        this.dialogPricingF = false;
                        this.$refs.formEventPriceFriend.resetValidation();
                        this.$refs.formEventPriceFriend.reset();
                        this.showSnackBar(this.$t("common.success"), "success");
                    } else if(response.message == "invalid_range_age") {
                        this.showSnackBarDialog(this.$t("page.events.pricing.invalid_range_age"), "error");
                    } else if(Array.isArray(response.message) && response.message.length > 0) {
                        this.showSnackBarDialog(this.$t("page.events.pricing." + response.message[0]), "error");
                    } else {
                        this.showSnackBarDialog(this.$t("common.failed"), "error");
                    }
                } else {
                    const response = await this.api(
                        "put",
                        "/api/v1/promoter/eventRegistrationPrice/spectatorsLanguage/" + this.itemFriendSel.id,
                        data
                    );
                    if(response.success) {
                        this.loadInformationLanguage();
                        this.dialogPricingF = false;
                        this.$refs.formEventPriceFriend.resetValidation();
                        this.$refs.formEventPriceFriend.reset();
                        this.showSnackBar(this.$t("common.success"), "success");
                    } else if(response.message == "invalid_range_age") {
                        this.showSnackBarDialog(this.$t("page.events.pricing.invalid_range_age"), "error");
                    } else if(Array.isArray(response.message) && response.message.length > 0) {
                        this.showSnackBarDialog(this.$t("page.events.pricing." + response.message[0]), "error");
                    } else {
                        this.showSnackBarDialog(this.$t("common.failed"), "error");
                    }
                }
            }
        },
        editItemPF(item) {
            this.itemFriendSel = item;
            this.eventPriceFriend.spanish = item.spanishDescription;
            this.eventPriceFriend.french = item.frenchDescription;
            this.eventPriceFriend.english = item.information;
            this.eventPriceFriend.price = item.price.replace("$","").replace(" ","");
            this.eventPriceFriend.ageMin = item.ageMin;
            this.eventPriceFriend.ageMax = item.ageMax;
            this.titleModal = this.$t("page.events.pricing.edit_friend_family");
            this.dialogPricingF = true;
        },
        confirmDeletePF(item) {
            this.dialogNotificationPF = true;
            this.itemFriendSel = item;
        },
        async deleteItemPF() {
            const response = await this.api(
                "delete",
                "/api/v1/promoter/eventRegistrationPrice/spectatorsLanguage/" + this.itemFriendSel.id
            );
            if(response.success) {
                this.maxRowPF = false;
                this.loadInformationLanguage();
            }
            this.dialogNotificationPF = false;
        }, 
        async loadInformationLanguage() {
            const response = await this.api(
                "get",
                "/api/v1/promoter/eventRegistrationPrice/spectatorsLanguage/" + this.$route.params.id
            );
            if(response.success) {
                this.rowsSpectatorsL = response.message.data.map((el) => {
                    let fDesc = el.descriptions.filter((el) => {
                        return el.languageCode == "fr";
                    });
                    let sDesc = el.descriptions.filter((el) => {
                        return el.languageCode == "es";
                    });
                    let eDesc = el.descriptions.filter((el) => {
                        return el.languageCode == "en";
                    });
                    return {
                        id: el.id,
                        information: eDesc.length > 0 ? eDesc[0].spectatorAddInfo : null,
                        price: `$ ${parseFloat(el.price).toFixed(2)}`,
                        frenchDescription: fDesc.length > 0 ? fDesc[0].spectatorAddInfo : null,
                        spanishDescription: sDesc.length > 0 ? sDesc[0].spectatorAddInfo : null,
                        ageMin: el.ageMin,
                        ageMax: el.ageMax
                    };
                });
            }
        },
    },
    created() {
        this.loadInformationLanguage();
    }
}
</script>